<template>
    <div>
        <b-container class="mt-3 min-h-100">
            <h4 class="mb-2">Header Key</h4>
            <b-row class="mb-1">
                <b-col lg="2" class="d-none d-lg-flex">key</b-col>

                <b-col lg="9" class="d-none d-lg-flex">
                    values </b-col>
            </b-row>
            <b-row v-for="(item ) in data" :key="item.id" class="">
                <b-col lg="2">
                    <InputText placeholder="key" customLabel type="text" v-model="item.header_key">
                        <template v-slot:textFloat>
                            <div class="d-lg-none mb-1">
                                key </div>
                        </template>
                    </InputText>
                </b-col>
                <b-col lg="9">
                    <InputText placeholder="values" customLabel type="text" v-model="item.header_value">
                        <template v-slot:textFloat>
                            <div class="d-lg-none mb-1">
                                values </div>
                        </template>
                    </InputText>

                </b-col>
                <b-col lg="1">
                    <b-button variant="link" class="text-danger" @click="deleteItemModal(item)">
                        <font-awesome-icon icon="trash-alt" title="Delete" class="main-color" />
                    </b-button>
                </b-col>

            </b-row>
            <div class="d-flex justify-content-center">
                <b-button class="main-color btn-save" @click="addItem">Add</b-button>
            </div>

        </b-container>
        <FooterAction @submit="update(0)" routePath="/setting" />
        <ModalPreviewBody ref="modal"></ModalPreviewBody>
    </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import ModalPreviewBody from "../modalPreviewBody.vue";

export default {
    components: { InputText, ModalPreviewBody },
    data() {
        return {
            data: [],
        };
    },
    methods: {
        async getData() {
            const response = await this.axios(`/webhook/ListHeader`);
            this.data = response.data.detail
        },
        async update() {
            this.$bus.$emit("showLoading");
            const response = await this.axios.post(
                `/webhook/UpdateHeader`,
                this.data
            )
            this.getData();
            this.$bus.$emit("hideLoading");
            if (response.data.result == 1) this.successAlert();
            else this.errorAlert(response.data.message);

        },
        deleteItemModal(item) {
            this.confirmAlert().then((val) => {
                if (val.isConfirmed) {
                    this.deleteItem(item);
                }
            });
        },
        async deleteItem(item) {
            if (item.id != 0) {
                this.$bus.$emit("showLoading");
                item.is_delete = true
                const response = await this.axios.post(
                    `webhook/UpdateHeader`,
                    [item]
                )
                this.getData();
                this.$bus.$emit("hideLoading");
                if (response.data.result == 1) this.successAlert();
                else this.errorAlert(response.data.message);
            }
            else {
                this.data = this.data.filter(x => x !== item);
            }
        },
        addItem() {
            this.data.push({
                id: 0,
            header_key: "",
            header_value: "",
            is_delete: false
            })
        },
        openModalPreview(example_json) {
            this.$refs.modal.openModal(example_json)
        }
    },
    mounted() {
        this.getData();
    },

};
</script>

<style scoped>
.text-highlight {
    color: var(--primary-color);
    font-weight: bold;
    opacity: 1 !important;
    text-decoration: underline;
}

.delete-buttton {
    color: #575757;
    background-color: #fff;
    border: 1px solid #575757;
}

.min-h-100 {
    min-height: 100%
}
</style>